import { Pair, Token } from 'archerswap-sdk'
import { useMemo } from 'react'
import farms from 'config/constants/farms'
import { PairState, usePairs } from '../data/Reserves'

export default function useFarmTvl(): [Pair, number][] {
  const allPairCombinations: [Token, Token][] = farms.map((farm) => [
    new Token(
      1116,
      farm.quoteToken.address[1116],
      farm.quoteToken.decimals,
      farm.quoteToken.symbol,
      farm.quoteToken.symbol,
    ),
    new Token(1116, farm.token.address[1116], farm.token.decimals, farm.token.symbol, farm.token.symbol),
  ])

  const allPairs = usePairs(allPairCombinations)

  // only pass along valid pairs, non-duplicated pairs
  const pairs = useMemo(
    () =>
      Object.values(
        allPairs
          // filter out invalid pairs
          .filter((result): result is [PairState.EXISTS, Pair] => Boolean(result[0] === PairState.EXISTS && result[1]))
          // filter out duplicated pairs
          .reduce<{ [pairAddress: string]: Pair }>((memo, [, curr]) => {
            memo[curr.liquidityToken.address] = memo[curr.liquidityToken.address] ?? curr
            return memo
          }, {}),
      ),
    [allPairs],
  )

  const wcorePrice = useMemo(() => {
    const pair = pairs.filter((e) => e.token0.symbol === 'WCORE' && e.token1.symbol === 'USDT')[0]
    if (pair) {
      return Number(pair.token0Price.toFixed())
    }

    return 0
  }, [pairs])

  const calcPairReserveUsd = (pair: Pair | undefined) => {
    if (!pair) {
      return 0
    }
    if (['USDT', 'USDC'].includes(pair.token0.symbol)) {
      return Number(pair.reserve0.toFixed()) * 2
    }
    if (['USDT', 'USDC'].includes(pair.token1.symbol)) {
      return Number(pair.reserve1.toFixed()) * 2
    }
    if (pair.token0.symbol === 'WCORE') {
      return Number(pair.reserve0.toFixed()) * 2 * wcorePrice
    }
    if (pair.token1.symbol === 'WCORE') {
      return Number(pair.reserve1.toFixed()) * 2 * wcorePrice
    }

    return 0
  }

  return pairs.map((e) => [e, calcPairReserveUsd(e)])
}
